// Values sourced from the VUI v5 Figma "Text field" component (node 1691:2232), verified against
// core/vuiProvider/consts.ts CSS variables. Where the semantic --vui-control-*/--vui-feedback-* var has
// drifted from the current design, the raw --vui-color-* palette var is used instead.
export const fieldColors = {
  border: 'var(--vui-control-border-default)',
  placeholder: 'var(--vui-control-placeholder)',
  inputText: 'var(--vui-control-foreground-default)',
  helpText: 'var(--vui-control-helper)',
  icons: 'var(--vui-foreground-muted)',
  disabledBackground: 'var(--vui-color-sandstone-90)',
  disabledForeground: 'var(--vui-color-sandstone-60)',
  // no Figma-verified readOnly token yet; same sandstone step as the old xstyled tokens, just as a CSS var
  readOnlyBackground: 'var(--vui-color-sandstone-97)',
  readOnlyBorder: 'var(--vui-color-sandstone-55)',
  focus: 'var(--vui-utility-focus)',
  error: 'var(--vui-action-danger-solid)',
  loading: 'var(--vui-color-sea-blue-80)',
  loadingBar: 'var(--vui-color-sea-blue-60)',
  success: 'var(--vui-feedback-success-solid)',
} as const

export const displayValueOnlyTextSize = {
  sm: 'xs',
  md: 'sm',
  lg: 'md',
  xl: 'lg',
} as const

export const clearIconSize = {
  sm: 'sm',
  md: 'sm',
  lg: 'sm',
  xl: 'md',
} as const

export const helpTextMargin = '60px' as const
